import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Sidebar } from "../sidebar/Sidebar";
import { TopBar } from "../topbar/TopBar";
import { MobileSidebar } from "../sidebar/MobileSidebar";

export const Default = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const TOKEN = window.localStorage.getItem("TOKEN");
    if (!TOKEN) navigate("/sign-in");
  }, [navigate]);

  return (
    <div className="mca-app">
      <Sidebar />
      <MobileSidebar />
      <div
        className="mca-sidebar-scrim"
        data-sidebar-scrim
        onClick={() => document.body.classList.remove("mca-sidebar-open")}
      ></div>
      <div className="mca-main">
        <TopBar />
        {/* Each screen provides its own .mca-content (matches the design HTML
            exactly) — Default must NOT wrap it, or content double-pads. */}
        {props.children}
      </div>
    </div>
  );
};
